import { render, staticRenderFns } from "./RecentlyViewedRooms.vue?vue&type=template&id=f099e47e&"
import script from "./RecentlyViewedRooms.vue?vue&type=script&lang=ts&"
export * from "./RecentlyViewedRooms.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports